import { CliApi } from 'osep-generator-service-client-v1';
import { useApiConfig } from '../useApiConfig';
import { CLI_QUERY_KEY } from '../../utils/consts';
import { CliData } from '../../cliDataSchema';
import { useQuery } from '@tanstack/react-query';

function useCli() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const cli = useQuery({
    queryKey: [CLI_QUERY_KEY],
    queryFn: async () => {
      const config = await getApiConfig();
      const cliApi = new CliApi(config, undefined, axiosInstance);
      const result = (await cliApi.getCli()).data;

      return result as CliData;
    },
  });
  return cli;
}

export default useCli;
